import gql from 'graphql-tag';

export const createMetric = gql`
  mutation createMetric($inputMetric: InputMetric) {
    createMetric(metric: $inputMetric) {
      data
    }
  }
`;
